import { render, staticRenderFns } from "./LogIn.vue?vue&type=template&id=048a1cae&scoped=true&"
import script from "./LogIn.vue?vue&type=script&lang=ts&"
export * from "./LogIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a1cae",
  null
  
)

export default component.exports